import { render, staticRenderFns } from "./sLandMonitor.vue?vue&type=template&id=60c04d26&scoped=true&"
import script from "./sLandMonitor.vue?vue&type=script&lang=js&"
export * from "./sLandMonitor.vue?vue&type=script&lang=js&"
import style0 from "./sLandMonitor.vue?vue&type=style&index=0&id=60c04d26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c04d26",
  null
  
)

export default component.exports